export const stringDivider = (text: string, width: number, spaceReplacer: string): string => {
  if (text.length > width) {
    let p = width;
    while (p > 0 && text[p] !== ' ' && text[p] !== '-') {
      p--;
    }
    if (p > 0) {
      let left;
      if (text.substring(p, p + 1) === '-') {
        left = text.substring(0, p + 1);
      } else {
        left = text.substring(0, p);
      }
      const right = text.substring(p + 1);
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
    }
  }
  return text;
};
